"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const shared_1 = require("../controls/chart/shared");
/**
 * Adapts our chart types to kendo chart types
 * @param {ChartType} chartType - The type of the chart
 * @param isStacked
 * @param isStackedChartByPercent
 * @returns {string} - the string representation of the chart type according to kendo API.
 */
function getChartType(chartType, isStacked = false, isStackedChartByPercent = false) {
    switch (chartType) {
        case shared_1.ChartType.BAR: {
            return isStacked ? (isStackedChartByPercent ? "BAR_100_PERCENT_STACKED" : "BAR_STACKED") : 'bar';
        }
        case shared_1.ChartType.COLUMN: {
            return isStacked ? (isStackedChartByPercent ? "COLUMN_100_PERCENT_STACKED" : "COLUMN_STACKED") : 'column';
        }
        case shared_1.ChartType.AREA: {
            return "area";
        }
        case shared_1.ChartType.VERTICAL_AREA: {
            return "verticalArea";
        }
        case shared_1.ChartType.LINE: {
            return "line";
        }
        case shared_1.ChartType.VERTICAL_LINE: {
            return "verticalLine";
        }
        default: {
            throw new Error(`${chartType} Categorical Chart is not supported`);
        }
    }
}
exports.getChartType = getChartType;
//# sourceMappingURL=utils.js.map